// extracted by mini-css-extract-plugin
module.exports = {"prev":"FullScreenCarousel_prev__2C3YB","next":"FullScreenCarousel_next__2mVaD","nav":"FullScreenCarousel_nav__2rooZ"};